import React, { useCallback, useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  Button,
  withStyles,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { Close as CloseIcon, ErrorOutline as ErrorOutlineIcon } from "@material-ui/icons";
import { withSnackbar } from "notistack";
import { postData } from "@componentAPIs";
import { withUserProfile } from "@withUserProfile";
import { compose } from "recompose";
import styles from "./styles";
import Cards from "../Cards";
import Events from "@EventEmitter";

const RevisitStopConfirmationPopup = (props: any) => {
  const { classes, stopData, open, handleClose, routeData, enqueueSnackbar, userData } = props;
  const [inProgress, setInProgress] = useState(false);

  const handleCancel = useCallback(() => {
    if (!inProgress) {
      handleClose();
    }
  }, [handleClose, inProgress]);

  const handleClosedRevisitStop = useCallback((data: any) => {
    if (data.isEventProcessed) {
      if (data.driverId === routeData.driverId) {
        enqueueSnackbar("Revisit stop added successfully.", {
          variant: "success",
        });
      }
      handleClose();
    } else {
      enqueueSnackbar("Failed to add revisit stop. Please try again.", {
        variant: "error",
      });
    }
  }, [enqueueSnackbar, handleClose, routeData.driverId]);

  useEffect(() => {
    Events.on("ClosedRevisitStop", handleClosedRevisitStop);
    return () => {
      Events.off("ClosedRevisitStop", handleClosedRevisitStop);
    };
  }, [handleClosedRevisitStop]);

  const handleConfirm = () => {
    setInProgress(true);
    const requestObj = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      routeId: routeData.routeId,
      stopId: stopData.stopId,
      manifestNumber: routeData.manifestNumber,
      revisitedStop: {
        proNumbers: stopData.shipments.map((shipment: any) => shipment.proId) || [],
      }
    };

    postData("RevisitDeliveryStop", requestObj)
      .then((response) => {
        if (response && Math.trunc(response.status / 100) !== 2) {
          const message = (response as any)?.data?.message || "Failed to add revisit stop.";
          enqueueSnackbar(message, { variant: "error" });
        }
      })
      .catch(() => {
        enqueueSnackbar("Failed to add revisit stop. Please try again.", {
          variant: "error",
        });
      });
  };
  if (!stopData) return null;
  return (
    <Dialog open={open} onClose={handleCancel} classes={{ paper: classes.dialog }}>
      <DialogTitle id="customized-dialog-title" classes={{ root: classes.dialogTitlestyle }} disableTypography>
        <div className={classes.titleContainer}>
          <div><ErrorOutlineIcon className={classes.errorIcon} /></div>
          <div className={classes.title}>Confirm Revisit</div>
        </div>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContents }}>
        <div className={classes.confirmationContent}>
          <div className={classes.confirmationMessage}>
            Are you sure you want to add this stop as a revisit to the route?
          </div>
          <div className={classes.cardsContainerSection}>
            <Cards
              key={`confirmation_stop_cards_${stopData.stopId}`}
              {...props}
              disableActions={true}
              defaultExpanded={true}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogFooter}>
        <Button
          onClick={handleCancel}
          color="primary"
          variant="outlined"
          disabled={inProgress}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={inProgress}
        >
          {inProgress ? <CircularProgress size={20} /> : "Confirm Revisit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar
)(RevisitStopConfirmationPopup);
